import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jconst(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>

<Sides/>
<Helmet>
 
 <title>Master the Art of Java Continue: A Beginner's Tutorial Guide by CodeExampler</title>
 <meta name="description" content="Learn how to use Java continue statements with CodeExampler's beginner-friendly tutorial. Discover how continue statements can be used to skip certain iterations in loops and nested loops. Get practical examples and improve your programming skills today!" />
<meta name="keywords" content="CodeExampler, Java, programming, tutorial, continue statement, for loop, while loop, nested loops, examples, beginner-friendly, programming skills" />
<link rel="canonical" href="https://www.codeexampler.com/java-continue" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Continue in Java
</h1>
<div className="first">
        <a href="/java-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-array">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">Java Continue Statement:</h2>
<p className="mt-4 para">A continue in Java is usually associated with an if.
</p>


<h2 className="headings">Syntax For Continue in java:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
  {"\n"}
  <span className="qwerty-3">&#123; </span>
  {"\n"}
  <span className="qwerty-1">&nbsp;Continue;</span>
  {"\n"}
  <span className="qwerty-3">&#125; </span>
  {"\n"}
  {"\n"}
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">How to use Continue in java with for loop:</h2>





<h2 className="headings">Q-Write a Program continue on if i=4 in java Continue Example?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              <span className="qwerty-10">class</span>
              <span className="qwerty-4"> Continue_example</span>
              <span className="qwerty-5">{`// class is a keyword`}</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
      

              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
              <span className="qwerty-4">i;</span>
              {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">1;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;</span>
      <span className="qwerty-1">10;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">++</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

      {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
      <span className="qwerty-1">(</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-8">==</span>
            <span className="qwerty-1">4</span>
            <span className="qwerty-1">)</span>
      {"\n"}

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;continue; </span>

      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">i</span>
          <span className="qwerty-1">);</span>
          {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
      


     
     



{"\n"}
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
        
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;1</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;2</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;3</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;4</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;5</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;6</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;7</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;8</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;9</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;10</span>
              {"\n"}
                </code>{"   "}
                </pre>
          </div>
        </div>



<h2 className="headings">Q-Write a Program if i=4 so print string and after continue loop work in java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Continue_example</span>
          <span className="qwerty-5">{`// class is a keyword`}</span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
          <span className="qwerty-4">i;</span>
          {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">);</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;continue; </span>

  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;2</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;3</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;this is continue</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;5</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;6</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;7</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;8</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;9</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;10</span>
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q- Write a Program uncheck if i=4 or i=8 continue in java examples?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Continue_example</span>
          <span className="qwerty-5">{`// class is a keyword`}</span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
          <span className="qwerty-4">i;</span>
          {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">);</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-8"> || </span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">8</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;continue; </span>

  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;2</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;3</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;this is continue</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;5</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;6</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;7</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;this is continue</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;9</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;10</span>
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a Program continue in java with array Example? </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Continue_example</span>
          <span className="qwerty-5">{`// class is a keyword`}</span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-6"> &#123; </span>
      <span className="qwerty-1"> 1,2,3,4,5,6,7,8,9,10 </span>
      <span className="qwerty-6"> &#125; ;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
  <span className="qwerty-2">int </span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">:</span>  
  <span className="qwerty-4">arr</span>  
  <span className="qwerty-1">);</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Continue No"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;continue; </span>

  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"not Continue Complete "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>          
          <span className="qwerty-5">&nbsp;1</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;2</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;3</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;This is Continue No</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;5</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;6</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;7</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;8</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;9</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;not Continue Complete </span>
          <span className="qwerty-5">&nbsp;10</span>
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-array">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jconst;